import { z } from 'zod';
import { CustomerProfileSchema } from './CustomerDetailsFormSection/sectionSchema';
import { DealDetailsSchema } from './DealDetailsFormSection/sectionSchema';
export const ReferralFormSchema = z
  .object({
    customerProfile: CustomerProfileSchema,
  })
  .merge(DealDetailsSchema);

export type ReferralFormFields = z.infer<typeof ReferralFormSchema>;
